import { Input, Select } from 'antd';
import { useFieldDefaults } from './defaults';
import type { StringField } from './types';

interface Props extends StringField {
  /** Value of the sibling grade field — used to filter sections. */
  grade?: string;
}

/**
 * Sections are filtered by the sibling grade value. When the tenant has no
 * structure configured or the picked grade has no sections, this degrades to
 * a free-text Input.
 */
export function SectionField({ value, onChange, grade, ...rest }: Props) {
  const defaults = useFieldDefaults();
  const options = defaults.section?.optionsFor(grade);

  if (!options || options.length === 0) {
    return (
      <Input
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={rest.placeholder ?? 'A'}
        {...rest}
      />
    );
  }

  return (
    <Select
      value={value || undefined}
      onChange={(v) => onChange?.(v)}
      options={options as unknown as { value: string; label: string }[]}
      placeholder={rest.placeholder ?? 'Pick a section'}
      allowClear
      disabled={rest.disabled}
      status={rest.status}
      id={rest.id}
    />
  );
}
